import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccessGuard } from "src/app/core/guards/access.guard";
import { OrdersListComponent } from "./orders-list/orders-list.component";

const routes: Routes = [
  {
    path: "",
    component: OrdersListComponent,
    canActivate: [AccessGuard],
    data: { permissionName: "Order", access: 1 },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
